import { render, staticRenderFns } from "./EWDInstalls.vue?vue&type=template&id=537e1886&"
import script from "./EWDInstalls.vue?vue&type=script&lang=js&"
export * from "./EWDInstalls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports